/* eslint-disable */
import { PlusOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Row, Typography
} from 'antd';
import React from 'react';
import { FormProvider, useFieldArray, UseFormReturn } from 'react-hook-form';

import Banks from './Banks';
import FormIdentitfy, { ButtonCheck } from './FormIdentitfy';
import { RequestStaffForm } from './Step3';

import { TableForm } from '.';

import { StaffDataType } from 'services/project/types';
import { formatDateDDMMYYYY, removeVietnameseDiacriticsAndUppercase } from 'utils/functions';

interface Step2Props {
  method: UseFormReturn<TableForm>;
  methodRegister: UseFormReturn<RequestStaffForm>;
  staffData?: StaffDataType
  isLoading: boolean;
  handleClick: () => void;
  buttonRecheck?: ButtonCheck;
}

const Step2: React.FC<Step2Props> = ({
  method, methodRegister, staffData, isLoading, handleClick, buttonRecheck
}) => {
  const { fields, append, remove } = useFieldArray({
    control: methodRegister.control,
    name: 'bankAccounts',
  });

  const errorState = methodRegister.formState.errors as unknown as {
    [x in keyof RequestStaffForm]: { message: string }
  };

  const { isDirty } = method.formState;

  const handleRemove = async (indexToRemove: number) => {
    await remove(indexToRemove);

    const accounts = methodRegister.getValues('bankAccounts');
    const hasDefault = accounts.some((b) => b.isDefault);

    if (!hasDefault && accounts.length > 0) {
      const lastIndex = accounts.length - 1;
      methodRegister.setValue(`bankAccounts.${lastIndex}.isDefault`, true);
    }
  };

  return (
    <div className="p-home__step2">
      <FormIdentitfy method={method} buttonRecheck={buttonRecheck} />
      <FormProvider {...methodRegister}>
        <Row gutter={16} className="p-home__step2__row">
          <Col xs={24} sm={8} className="u-mb-16">
            <Typography.Text strong>
              Họ và Tên
              {' '}
            </Typography.Text>
            <div>
              <Typography.Text className="p-home__step2__value">
                {staffData?.staffData?.fullname || ''}
              </Typography.Text>
            </div>
          </Col>
          <Col xs={24} sm={8} className="u-mb-16">
            <Typography.Text strong>
              Ngày sinh
              {' '}
            </Typography.Text>
            <div>
              <Typography.Text className="p-home__step2__value">
                {formatDateDDMMYYYY(staffData?.staffData?.dob)}
              </Typography.Text>
            </div>
          </Col>
          <Col xs={24} sm={8} className="u-mb-16">
            <Typography.Text strong>
              Mã số thuế
              {' '}
            </Typography.Text>
            <div>
              <Typography.Text className="p-home__step2__value">
                {staffData?.staffData?.taxCode || ''}
              </Typography.Text>
            </div>
          </Col>
          <Col xs={24} sm={8} className="u-mb-16 cccd">
            <Typography.Text strong>
              Số CCCD
              {' '}
            </Typography.Text>
            <div>
              <Typography.Text className="p-home__step2__value">
                {staffData?.staffData?.idCardNumber || ''}
              </Typography.Text>
            </div>
          </Col>
          <Col xs={24} sm={8} className="u-mb-16 cccd">
            <Typography.Text strong>
              Số điện thoại
              {' '}
            </Typography.Text>
            <div>
              <Typography.Text className="p-home__step2__value">
                {staffData?.staffData?.phoneNumber || ''}
              </Typography.Text>
            </div>
          </Col>
          <Col xs={24} sm={8} className="u-mb-16 cccd">
            <Typography.Text strong>
              Hộ khẩu thường trú
              {' '}
            </Typography.Text>
            <div>
              <Typography.Text className="p-home__step2__value">
                {staffData?.staffData?.permanentAddress || ''}
              </Typography.Text>
            </div>
          </Col>
          <Card
            title={<Typography.Title level={4} className="p-home__card-title">Ngân hàng</Typography.Title>}
            className="u-mt-16 p-home__card-title"
            style={{ width: '100%' }}
          >
            {
              fields.map((f, index) => (
                <Banks
                  key={f.id}
                  positionBank={index}
                  method={methodRegister}
                  remove={handleRemove}
                  bankData={staffData?.bankData}
                />
              ))
            }
            {errorState.bankAccounts
              && (
                <Typography.Text type="danger">
                  {errorState.bankAccounts.message}
                </Typography.Text>
              )}
            <Button
              className="u-mt-16"
              style={{ display: 'block', marginLeft: 'auto' }}
              type="primary"
              onClick={() => {
                if (!methodRegister.getValues('fullname')) {
                  methodRegister.setError('bankAccounts', {
                    type: 'custom',
                    message: 'Vui lòng nhập Họ và Tên'
                  });
                } else {
                  methodRegister.getValues('bankAccounts').forEach((_, index) => {
                    methodRegister.setValue(`bankAccounts.${index}.isDefault`, false);
                  });
                  append({
                    bankOwner: removeVietnameseDiacriticsAndUppercase(staffData?.staffData.fullname),
                    bankAccount: '',
                    isDefault: true,
                    bankName: null,
                    bankBranch: null,
                    city: null,
                    isActive: true
                  });
                }
              }}
              icon={<PlusOutlined />}
            >
              <span style={{ display: 'inline-block', marginLeft: '8px' }}>
                Thêm tài khoản
              </span>
            </Button>
          </Card>
          <div className="p-home__step2_btnWrap">
            <Button
              onClick={handleClick}
              className="p-home__step1__btn"
              type="primary"
              disabled={isLoading || isDirty}
            >
              Gửi thông tin đăng ký
            </Button>
          </div>
        </Row>
      </FormProvider>
    </div>
  );
};

export default React.memo(Step2);
